import { useCallback, useEffect, useState } from "react";
import { loadDepositAddress } from "../wallet/custodial/api";
import { useGen1Nav } from "./useGen1Nav";

/** Player's mainnet deposit address (§9.3). SOL sent here is credited as rSOL. */
export function DepositScreen({ onBack }: { onBack: () => void }) {
  const [address, setAddress] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    let cancel = false;
    void loadDepositAddress()
      .then((depositAddress) => {
        if (!cancel) setAddress(depositAddress);
      })
      .catch((e: unknown) => {
        if (!cancel) setError(e instanceof Error ? e.message : String(e));
      });
    return () => {
      cancel = true;
    };
  }, []);

  const copy = useCallback(() => {
    if (!address) return;
    void navigator.clipboard.writeText(address).then(() => setCopied(true));
  }, [address]);

  const items = address ? ["COPY", "BACK"] : ["BACK"];
  const onA = useCallback(
    (i: number) => {
      if (items[i] === "COPY") copy();
      else onBack();
    },
    [items, copy, onBack],
  );
  const { index } = useGen1Nav(items.length, onA, onBack);

  return (
    <>
      <h2 className="wallet-menu__title">DEPOSIT</h2>
      <p className="wallet-menu__hint">Send SOL, RCD, items, or Pokémon on mainnet. SOL arrives as rSOL.</p>
      {address ? <p className="wallet-menu__address">{address}</p> : <p className="wallet-menu__hint">{error ?? "Loading…"}</p>}
      {copied && <p className="wallet-menu__status ok">Copied.</p>}
      <ul className="wallet-menu__list" role="listbox">
        {items.map((label, i) => (
          <li key={label} role="option" aria-selected={i === index} onClick={() => onA(i)}>
            <span className="wallet-menu__cursor" aria-hidden="true">
              {i === index ? "\u25b6" : "\u00a0"}
            </span>
            <span className="wallet-menu__label">{label}</span>
          </li>
        ))}
      </ul>
    </>
  );
}
